import { GetterTree } from "vuex";
import { IExpeditionState } from "./state";
import { IExpedition, IExpeditionDay, IExpeditionAutoControl, IExpeditionNotification, IExpeditionSlot } from "@/models";

export const getters: GetterTree<IExpeditionState, any> = {
    getExpeditionDay: (state) => (): IExpeditionDay => {
        return state.expeditionDay;
    },

    notifications: (state) => (): IExpeditionNotification[] => {
        return state.notifications;
    },

    getSelectedExpedition: (state) => (): IExpedition => {
        return state.selectedExpedition;
    },

    getAutoControlPictures: (state) => (): string[] => {
        return state.picturesAutoControl;
    },

    getEndLoadPictures: (state) => (): string[] => {
        return state.picturesEndLoad;
    },

    getExpeditionAutoControl: (state) => (): IExpeditionAutoControl => {
        return state.expeditionAutoControl;
    },

    getSelectedNotification: (state) => (): IExpeditionNotification => {
        return state.selectedNotification;
    },
};
